import React from 'react'
import PropTypes from 'prop-types'

import TrackKeys from './TrackKeys'

const Body = ({ tracks, toggleTrackOpen, clickTrackButton, editMode, assignmentEdits, setAssignmentEdits, pmResourceNames,profile_data }) => (
  <div className="rt-sidebar__body">
    <TrackKeys tracks={tracks} toggleOpen={toggleTrackOpen} clickTrackButton={clickTrackButton} editMode={editMode} assignmentEdits={assignmentEdits} setAssignmentEdits={setAssignmentEdits} pmResourceNames={pmResourceNames} profile_data={profile_data} />
  </div>
)

Body.propTypes = {
  tracks: PropTypes.arrayOf(PropTypes.shape({})),
  toggleTrackOpen: PropTypes.func,
  clickTrackButton: PropTypes.func,
}

export default Body
